<template>
  <v-form ref="form">
    <app-loading :loading="loading">
      <app-exercises parent="grammar_step" :grammar_step="grammar_step" />
    </app-loading>
  </v-form>
</template>
<script>
import rulesMixin from "@/mixins/rulesMixin";
import restoreMixin from "@/mixins/restoreMixin";
import Exercises from "./Grammar/Exercises.vue";
import { getLessonGrammar } from "@/api/api";
import Loading from "@/components/Loading.vue";

export default {
  components: {
    appExercises: Exercises,
    appLoading: Loading,
  },
  mixins: [rulesMixin, restoreMixin],
  data() {
    return {
      grammar_step: {},
      loading: true,
    };
  },
  computed: {
    teacher_lesson: {
      get() {
        return this.$store.getters["admin/teacher_lesson"];
      },
      set(value) {
        this.$store.commit("admin/teacher_lesson", value);
      },
    },
  },
  async created() {
    this.create();
  },
  methods: {
    async create() {
      const uuid = this.teacher_lesson.grammar_step;
      if (uuid) {
        this.loading = true;
        const response = await getLessonGrammar(uuid);
        this.grammar_step = response.data;
      }
      this.loading = false;
    },
  },
};
</script>
